












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class NoAlgoliaHits extends Vue {
  @Prop(Boolean) private inHeader!: boolean;
  @Prop(Boolean) private mobile!: boolean;
}
